(() => {
  const STORAGE_KEY = 'toasty_shipping_country';

  const countryFlag = (iso) => {
    if (!iso || iso.length !== 2) return '🌍';
    return String.fromCodePoint(
      ...iso.toUpperCase().split('').map((letter) => 127397 + letter.charCodeAt(0))
    );
  };

  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const dialog = root.querySelector('[data-toasty-destination-dialog]');
    const openButton = root.querySelector('[data-toasty-destination-open]');
    const closeButtons = root.querySelectorAll('[data-toasty-destination-close]');
    const countryButtons = root.querySelectorAll('[data-toasty-country-option]');
    const select = root.querySelector('[data-toasty-country-select]');
    const countryInput = root.querySelector('[data-toasty-country-input]');
    const restSubmit = root.querySelector('[data-toasty-rest-submit]');
    const form = root.querySelector('form');
    const currentCountry = root.dataset.countryCode || '';
    let lastFocusedElement = null;

    root.querySelectorAll('[data-toasty-country-flag]').forEach((target) => {
      target.textContent = countryFlag(currentCountry);
    });

    const saveCountry = (countryCode) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, countryCode || currentCountry);
      } catch (error) {
        // Country selection still works when storage is unavailable.
      }
    };

    const openDialog = () => {
      if (!dialog) return;
      lastFocusedElement = document.activeElement;
      dialog.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(() => {
        const currentOption = root.querySelector('[data-toasty-country-option][aria-current="true"]');
        (currentOption || select)?.focus();
      });
    };

    const closeDialog = () => {
      if (!dialog) return;
      saveCountry(currentCountry);
      dialog.hidden = true;
      document.documentElement.style.overflow = '';
      lastFocusedElement?.focus?.();
    };

    countryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const countryCode = button.dataset.countryCode || currentCountry;
        if (countryInput) countryInput.value = countryCode;
        saveCountry(countryCode);
      });
    });

    select?.addEventListener('change', () => {
      if (countryInput && select.value) countryInput.value = select.value;
    });

    restSubmit?.addEventListener('click', (event) => {
      if (!select?.value) {
        event.preventDefault();
        select?.focus();
        return;
      }
      if (countryInput) countryInput.value = select.value;
      saveCountry(select.value);
    });

    form?.addEventListener('submit', () => saveCountry(countryInput?.value));
    openButton?.addEventListener('click', openDialog);
    closeButtons.forEach((button) => button.addEventListener('click', closeDialog));
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDialog();
    });

    if (root.dataset.promptEnabled === 'true') {
      let savedCountry = null;
      try {
        savedCountry = window.localStorage.getItem(STORAGE_KEY);
      } catch (error) {
        // Show the prompt when storage cannot be read.
      }
      if (!savedCountry || savedCountry !== currentCountry) openDialog();
    }
  };

  const initAll = () => document.querySelectorAll('[data-toasty-destination-root]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
